import { ReportProfileAlertRulesComputedDelegateModel } from '../profile/report-profile-alert-rules-computed-delegate-model';

export class MicrosoftOfficeReportProfileAlertRulesComputedDelegateModel extends ReportProfileAlertRulesComputedDelegateModel {
  inboxIsValid: boolean;
  calendarIsValid: boolean;
  folderIsValid: boolean;
  instantMessagingShareIsValid: boolean;
}
